import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { convertToLocalDate, ToastComponent } from '../../core';
import { DateRange } from '../../shared';
import { NavbarComponent } from '../navbar';
import { SidebarComponent } from '../sidebar';


/**
 * Main container of application.
 */
@Component({
	selector: 'tsp-container-template',
	imports: [
		RouterOutlet,
		ToastComponent,
		NavbarComponent,
		SidebarComponent
	],
	templateUrl: './container-template.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ContainerTemplateComponent {

	//remove
	date: Date | null = null;
	dateFormat: string | null = null;
	dateRange: DateRange | null = null;
	dateRangeFormat: string | null = null;

	update(date: Date | null): void {
		this.date = date;
		this.dateFormat = date ? convertToLocalDate(date) : null;
	}

	clear(): void {
		this.date = null;
		this.dateFormat = null;
	}

	updateRange(range: DateRange | null): void {
		this.dateRange = range;
		this.dateRangeFormat = range ? `${convertToLocalDate(range.from, false)} - ${convertToLocalDate(range.to, false)}` : null;
	}

	clearRange(): void {
		this.dateRange = null;
		this.dateRangeFormat = null;
	}
}
